import { 
  Brain, Cloud, Code, Database, Server, Shield, Zap, 
  BarChart3, Cpu, Globe, Smartphone, TestTube, Users, 
  Link, BookOpen, Braces, Coffee, Layers, GitBranch,
  LineChart, PieChart, Workflow, Bot, Lock, Boxes,
  type LucideIcon
} from 'lucide-react';

export interface CategoryTheme {
  gradient: string;
  icon: LucideIcon;
  accent: string;
  fallbackColor: string;
  iconBg: string;
}

const themes: Record<string, CategoryTheme> = {
  'ai': {
    gradient: 'from-purple-600 via-violet-500 to-pink-500',
    icon: Brain,
    accent: 'purple',
    fallbackColor: 'hsl(271 91% 65%)',
    iconBg: 'bg-purple-500/20'
  },
  'azure': {
    gradient: 'from-blue-600 via-cyan-500 to-blue-400',
    icon: Cloud,
    accent: 'blue',
    fallbackColor: 'hsl(207 90% 54%)',
    iconBg: 'bg-blue-500/20'
  },
  'aws': {
    gradient: 'from-orange-500 via-amber-500 to-yellow-400',
    icon: Cloud,
    accent: 'orange',
    fallbackColor: 'hsl(25 95% 53%)',
    iconBg: 'bg-orange-500/20'
  },
  'python': {
    gradient: 'from-yellow-500 via-green-500 to-blue-500',
    icon: Code,
    accent: 'yellow',
    fallbackColor: 'hsl(48 96% 53%)',
    iconBg: 'bg-yellow-500/20'
  },
  'sql': {
    gradient: 'from-teal-500 via-cyan-500 to-blue-400',
    icon: Database,
    accent: 'teal',
    fallbackColor: 'hsl(173 80% 40%)',
    iconBg: 'bg-teal-500/20'
  },
  'react': {
    gradient: 'from-cyan-400 via-blue-500 to-indigo-500',
    icon: Braces,
    accent: 'cyan',
    fallbackColor: 'hsl(189 94% 43%)',
    iconBg: 'bg-cyan-500/20'
  },
  'javascript': {
    gradient: 'from-yellow-400 via-orange-400 to-yellow-500',
    icon: Braces,
    accent: 'yellow',
    fallbackColor: 'hsl(45 93% 47%)',
    iconBg: 'bg-yellow-500/20'
  },
  'java': {
    gradient: 'from-red-500 via-orange-500 to-red-600',
    icon: Coffee,
    accent: 'red',
    fallbackColor: 'hsl(0 72% 51%)',
    iconBg: 'bg-red-500/20'
  },
  'dotnet': {
    gradient: 'from-purple-600 via-violet-600 to-indigo-600',
    icon: Layers,
    accent: 'purple',
    fallbackColor: 'hsl(262 83% 58%)',
    iconBg: 'bg-purple-500/20'
  },
  'gcp': {
    gradient: 'from-blue-500 via-green-400 to-yellow-400',
    icon: Cloud,
    accent: 'blue',
    fallbackColor: 'hsl(217 91% 60%)',
    iconBg: 'bg-blue-500/20'
  },
  'data-science': {
    gradient: 'from-indigo-500 via-purple-500 to-pink-500',
    icon: BarChart3,
    accent: 'indigo',
    fallbackColor: 'hsl(239 84% 67%)',
    iconBg: 'bg-indigo-500/20'
  },
  'data-engineering': {
    gradient: 'from-blue-600 via-indigo-500 to-violet-500',
    icon: Server,
    accent: 'blue',
    fallbackColor: 'hsl(217 91% 60%)',
    iconBg: 'bg-blue-500/20'
  },
  'machine-learning': {
    gradient: 'from-violet-500 via-purple-500 to-fuchsia-500',
    icon: Cpu,
    accent: 'violet',
    fallbackColor: 'hsl(258 90% 66%)',
    iconBg: 'bg-violet-500/20'
  },
  'ml': {
    gradient: 'from-violet-500 via-purple-500 to-fuchsia-500',
    icon: Cpu,
    accent: 'violet',
    fallbackColor: 'hsl(258 90% 66%)',
    iconBg: 'bg-violet-500/20'
  },
  'powerbi': {
    gradient: 'from-yellow-500 via-amber-500 to-orange-500',
    icon: PieChart,
    accent: 'yellow',
    fallbackColor: 'hsl(48 96% 53%)',
    iconBg: 'bg-yellow-500/20'
  },
  'tableau': {
    gradient: 'from-blue-500 via-sky-400 to-orange-400',
    icon: LineChart,
    accent: 'blue',
    fallbackColor: 'hsl(217 91% 60%)',
    iconBg: 'bg-blue-500/20'
  },
  'security': {
    gradient: 'from-green-600 via-emerald-500 to-teal-500',
    icon: Shield,
    accent: 'green',
    fallbackColor: 'hsl(142 71% 45%)',
    iconBg: 'bg-green-500/20'
  },
  'devops': {
    gradient: 'from-blue-500 via-purple-500 to-pink-500',
    icon: GitBranch,
    accent: 'blue',
    fallbackColor: 'hsl(217 91% 60%)',
    iconBg: 'bg-blue-500/20'
  },
  'workflow': {
    gradient: 'from-orange-500 via-red-500 to-pink-500',
    icon: Workflow,
    accent: 'orange',
    fallbackColor: 'hsl(25 95% 53%)',
    iconBg: 'bg-orange-500/20'
  },
  'workflow-automation': {
    gradient: 'from-orange-500 via-amber-500 to-yellow-500',
    icon: Bot,
    accent: 'orange',
    fallbackColor: 'hsl(25 95% 53%)',
    iconBg: 'bg-orange-500/20'
  },
  'automation': {
    gradient: 'from-blue-500 via-cyan-500 to-teal-500',
    icon: Zap,
    accent: 'blue',
    fallbackColor: 'hsl(217 91% 60%)',
    iconBg: 'bg-blue-500/20'
  },
  'cloud': {
    gradient: 'from-sky-500 via-blue-500 to-indigo-500',
    icon: Cloud,
    accent: 'sky',
    fallbackColor: 'hsl(199 89% 48%)',
    iconBg: 'bg-sky-500/20'
  },
  'api': {
    gradient: 'from-green-500 via-emerald-500 to-teal-500',
    icon: Link,
    accent: 'green',
    fallbackColor: 'hsl(142 71% 45%)',
    iconBg: 'bg-green-500/20'
  },
  'database': {
    gradient: 'from-teal-500 via-cyan-500 to-blue-500',
    icon: Database,
    accent: 'teal',
    fallbackColor: 'hsl(173 80% 40%)',
    iconBg: 'bg-teal-500/20'
  },
  'analytics': {
    gradient: 'from-blue-500 via-indigo-500 to-purple-500',
    icon: BarChart3,
    accent: 'blue',
    fallbackColor: 'hsl(217 91% 60%)',
    iconBg: 'bg-blue-500/20'
  },
  'web': {
    gradient: 'from-pink-500 via-rose-500 to-orange-400',
    icon: Globe,
    accent: 'pink',
    fallbackColor: 'hsl(330 81% 60%)',
    iconBg: 'bg-pink-500/20'
  },
  'mobile': {
    gradient: 'from-green-500 via-teal-500 to-cyan-500',
    icon: Smartphone,
    accent: 'green',
    fallbackColor: 'hsl(142 71% 45%)',
    iconBg: 'bg-green-500/20'
  },
  'testing': {
    gradient: 'from-green-500 via-emerald-400 to-teal-400',
    icon: TestTube,
    accent: 'green',
    fallbackColor: 'hsl(142 71% 45%)',
    iconBg: 'bg-green-500/20'
  },
  'agile': {
    gradient: 'from-blue-500 via-cyan-500 to-green-500',
    icon: Users,
    accent: 'blue',
    fallbackColor: 'hsl(217 91% 60%)',
    iconBg: 'bg-blue-500/20'
  },
  'blockchain': {
    gradient: 'from-amber-500 via-yellow-500 to-orange-500',
    icon: Lock,
    accent: 'amber',
    fallbackColor: 'hsl(38 92% 50%)',
    iconBg: 'bg-amber-500/20'
  },
  'iot': {
    gradient: 'from-teal-500 via-green-500 to-emerald-400',
    icon: Boxes,
    accent: 'teal',
    fallbackColor: 'hsl(173 80% 40%)',
    iconBg: 'bg-teal-500/20'
  }
};

const defaultTheme: CategoryTheme = {
  gradient: 'from-slate-600 via-slate-500 to-slate-400',
  icon: BookOpen,
  accent: 'slate',
  fallbackColor: 'hsl(215 16% 47%)',
  iconBg: 'bg-slate-500/20'
};

export function getCategoryTheme(category: string | undefined | null): CategoryTheme {
  if (!category) return defaultTheme;
  
  const normalizedCategory = category.toLowerCase().replace(/\s+/g, '-');
  return themes[normalizedCategory] || defaultTheme;
}

export function getAllCategoryThemes(): Record<string, CategoryTheme> {
  return themes;
}

export function getCategoryList(): string[] {
  return Object.keys(themes);
}
